import Lightup from '@/views/lightup/Lightup';
import Beginnings from '@/views/lightup/Beginnings';
import JustStart from '@/views/lightup/JustStart';
import Projection from '@/views/lightup/Projection';
import Dreams from '@/views/lightup/Dreams';
import Coffee from '@/views/lightup/Coffee';
import Kgl from '@/views/lightup/Kgl';

export default {
  path: '/lightup',
  name: 'LightUp',
  component: Lightup,
  children: [
    {
      path: 'beginnings',
      name: 'Beginnings',
      component: Beginnings,
    },
    {
      path: 'just-start',
      name: 'JustStart',
      component: JustStart,
    },
    {
      path: 'projection',
      name: 'Projection',
      component: Projection,
    },
    {
      path: 'dreams',
      name: 'Dreams',
      component: Dreams,
    },
    {
      path: 'coffee',
      name: 'Coffee',
      component: Coffee,
    },
    {
      path: 'kgl',
      name: 'Kgl',
      component: Kgl,
    },
  ],
};
